"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SenderImageFull_1 = require("./components/SenderImageFull");
var discardSenderImageOption_1 = require("./actions/discardSenderImageOption");
var saveSenderImageOption_1 = require("./actions/saveSenderImageOption");
var isSenderImageOptionDirty_1 = require("./utils/isSenderImageOptionDirty");
var isSenderImageEnabled_1 = require("./utils/isSenderImageEnabled");
var SenderImageOption = {
    key: 'senderImage',
    titleStringKey: 'optionTitle_senderImage',
    searchTermsStringKey: 'optionTitle_senderImage',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SenderImageFull_1.default, null); },
        isDirty: isSenderImageOptionDirty_1.default,
        onSave: saveSenderImageOption_1.default,
        onDiscard: discardSenderImageOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isSenderImageEnabled_1.default,
            onToggle: saveSenderImageOption_1.onSenderImageToggle,
        },
        order: 4 /* SenderImage */,
        workloads: 1 /* Mail */,
    },
};
exports.default = SenderImageOption;
//# sourceMappingURL=SenderImageOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-image-option/lib/SenderImageOption.js
// module id = 5099
// module chunks = 2